import { type ReactElement } from 'react';

export function DMKPISummary(): ReactElement {
  return <div />;
}
